export default "__VITE_ASSET__BVldGCHj__"